const env = "local"

// export const getApi = () => {
//   return env === "local" ? "http://localhost:9000" : "https://api.eduudr.org";
// };


//  local & production testing 
export const getApi = () => {
  return  "https://app.eduudr.org";
};